import React, { ReactElement } from "react";
import Privacy from "@components/websitebuilderselect/privacy";
import { GetServerSideProps } from "next";
import WebsiteBuilderSelectWrapper from "@components/layouts/websiteBuilderSelectWrapper";
import { getPageProps } from "@services/initial-calls";

export default function PrivacyPage(): ReactElement {
    return (
        <WebsiteBuilderSelectWrapper useSecondaryLogo>
            <Privacy />
        </WebsiteBuilderSelectWrapper>
    );
}
export const getServerSideProps: GetServerSideProps = async (context) => {
    const props = await getPageProps(context, "home", {
        pageTitle: "Privacy Policy",
    });
    return props;
};
